// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"cae683bf","4469":"cae683bf"}[chunkId] + ".chunk.css";
};